export default {
	SET_COLOR: "SET_COLOR"
}



// WEBPACK FOOTER //
// ./src/actionCreators/backgroundActionNames.js